import React, { useContext, useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import InputAdornment from '@mui/material/InputAdornment'
import { AuctionContext } from '../context/auctionContext'
import { socketAdmin } from '../services/socketAuction'

export default function AutomaticAuctionDialog({ open, setOpen }) {
  const { auction } = useContext(AuctionContext)
  const auctionSettings = auction.settings.automaticAuction
  const [settings, setSettings] = useState({
    active: auctionSettings.active,
    presentTime: auctionSettings.presentTime,
    offerTime: auctionSettings.offerTime,
    awardTime: auctionSettings.awardTime,
  })
  const handleClose = () => {
    setOpen(false)
  }

  const handleOk = () => {
    socketAdmin.emit('toggleAutomaticAuction', {
      auctionId: auction.id,
      settings: { ...settings, active: !auctionSettings.active },
    })
    setOpen(false)
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Remate Automático</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Para activar el remate automático, ingrese los siguientes tiempos en
          SEGUNDOS:
          <Box>
            <TextField
              fullWidth
              label="Tiempo de Presentación"
              type="number"
              value={settings.presentTime}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  presentTime: parseInt(e.target.value),
                })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">Segundos</InputAdornment>
                ),
              }}
            />
            <TextField
              fullWidth
              label="Tiempo de Cierre de Ofertas"
              type="number"
              value={settings.offerTime}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  offerTime: parseInt(e.target.value),
                })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">Segundos</InputAdornment>
                ),
              }}
            />
            <TextField
              fullWidth
              label="Tiempo de Adjudicación"
              type="number"
              value={settings.awardTime}
              onChange={(e) =>
                setSettings({
                  ...settings,
                  awardTime: parseInt(e.target.value),
                })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">Segundos</InputAdornment>
                ),
              }}
            />
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleOk} color="primary" autoFocus>
          {auction.settings.automaticAuction.active ? 'Desactivar' : 'Activar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
